import React from "react";
import "./integrationPoP.css";
import icon1 from "../../assets/HomePage/icon1.png";
import icon2 from "../../assets/HomePage/icon2.png";
import icon3 from "../../assets/HomePage/icon3.png";
import icon4 from "../../assets/HomePage/icon4.png";
import icon5 from "../../assets/HomePage/icon5.png";
import icon6 from "../../assets/HomePage/icon6.png";

function IntegrationPoP() {
  return (
    <div>
      <div className="integration_outer">
        <div className="integration_left">
          <div className="integration_l1">
            <div className="integration_circle">
              <img src={icon1} alt="icon1" />
            </div>
            <div className="integration_content">
              <h1 className="integration_heading">Business Development</h1>
              <p className="integration_para">
                Effortlessly track sales pipelines, manage client relationships,
                and discover growth opportunities, enabling you to focus on
                building a stronger business.
              </p>
            </div>
          </div>
          <div className="integration_l1">
            <div className="integration_circle">
              <img src={icon3} alt="icon2" />
            </div>
            <div className="integration_content">
              <h1 className="integration_heading">Human Resources </h1>
              <p className="integration_para">
                Simplify HR operations like payroll, recruitment, and
                performance management while fostering better employee
                engagement and organizational efficiency.{" "}
              </p>
            </div>
          </div>
          <div className="integration_l1">
            <div className="integration_circle">
              <img src={icon5} alt="icon3" />
            </div>
            <div className="integration_content">
              <h1 className="integration_heading">Lead Generation </h1>
              <p className="integration_para">
                Capture, organize, and nurture leads seamlessly, enhancing
                conversions and aligning sales efforts for maximum efficiency.{" "}
              </p>
            </div>
          </div>
        </div>
        <div className="integration_right">
          <div className="integration_l1">
            <div className="integration_circle">
              <img src={icon2} alt="icon4" />
            </div>
            <div className="integration_content">
              <h1 className="integration_heading">Marketing </h1>
              <p className="integration_para">
                Automate marketing campaigns and gain actionable insights with
                real-time performance tracking, ensuring your strategies are
                data-driven and impactful.{" "}
              </p>
            </div>
          </div>
          <div className="integration_l1">
            <div className="integration_circle">
              <img src={icon4} alt="icon5" />
            </div>
            <div className="integration_content">
              <h1 className="integration_heading">Finance </h1>
              <p className="integration_para">
                Gain control over budgets, expenses, and financial planning with
                accurate tracking and detailed reporting to make smarter
                financial decisions.
              </p>
            </div>
          </div>
          <div className="integration_l1">
            <div className="integration_circle">
              <img src={icon6} alt="icon6" />
            </div>
            <div className="integration_content">
              <h1 className="integration_heading">Training & Learning </h1>
              <p className="integration_para">
                Deliver structured and engaging training programs while tracking
                employee progress to foster continuous growth and development.{" "}
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default IntegrationPoP;
